/**
 * @generated SignedSource<<516e1120757017c45332ecc4ea74ce73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WrappedDelegatesOrder = "leastVotesCast" | "mostNounsRepresented" | "mostRecentlyActive" | "mostRelevant" | "mostVotesCast" | "%future added value";
export type WrappedDelegatesWhere = "seekingDelegation" | "withStatement" | "%future added value";
export type DelegatesContainerPaginationQuery$variables = {
  after?: string | null;
  filterBy?: WrappedDelegatesWhere | null;
  first?: number | null;
  orderBy?: WrappedDelegatesOrder | null;
};
export type DelegatesContainerPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DelegatesContainerFragment">;
};
export type DelegatesContainerPaginationQuery = {
  response: DelegatesContainerPaginationQuery$data;
  variables: DelegatesContainerPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterBy"
  },
  {
    "defaultValue": 30,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": "mostRelevant",
    "kind": "LocalArgument",
    "name": "orderBy"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "filterBy"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DelegatesContainerPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "filterBy",
            "variableName": "filterBy"
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "DelegatesContainerFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DelegatesContainerPaginationQuery",
    "selections": [
      {
        "alias": "voters",
        "args": (v4/*: any*/),
        "concreteType": "WrappedDelegatesConnection",
        "kind": "LinkedField",
        "name": "wrappedDelegates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WrappedDelegatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WrappedDelegate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DelegateStatement",
                    "kind": "LinkedField",
                    "name": "statement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "twitter",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "discord",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statement",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "summary",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResolvedName",
                        "kind": "LinkedField",
                        "name": "resolvedName",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Delegate",
                    "kind": "LinkedField",
                    "name": "delegate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "delegatedVotesRaw",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 60
                          }
                        ],
                        "concreteType": "Noun",
                        "kind": "LinkedField",
                        "name": "nounsRepresented",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "number",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seed",
                            "kind": "LinkedField",
                            "name": "seed",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "accessory",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "background",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "body",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "glasses",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "head",
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": "nounsRepresented(first:60)"
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DelegateVotesSummary",
                        "kind": "LinkedField",
                        "name": "voteSummary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalVotes",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "voters",
        "args": (v4/*: any*/),
        "filters": [
          "orderBy",
          "where"
        ],
        "handle": "connection",
        "key": "DelegatesContainerFragment_voters",
        "kind": "LinkedHandle",
        "name": "wrappedDelegates"
      }
    ]
  },
  "params": {
    "cacheID": "935be64518e0dcf687237efe897faf02",
    "id": null,
    "metadata": {},
    "name": "DelegatesContainerPaginationQuery",
    "operationKind": "query",
    "text": "query DelegatesContainerPaginationQuery(\n  $after: String\n  $filterBy: WrappedDelegatesWhere\n  $first: Int = 30\n  $orderBy: WrappedDelegatesOrder = mostRelevant\n) {\n  ...DelegatesContainerFragment_3Jfei\n}\n\nfragment DelegateDialogFragment on WrappedDelegate {\n  address {\n    resolvedName {\n      address\n      ...NounResolvedNameFragment\n    }\n  }\n  delegate {\n    delegatedVotesRaw\n    nounsRepresented(first: 60) {\n      id\n      ...NounImageFragment\n    }\n    id\n  }\n}\n\nfragment DelegatesContainerFragment_3Jfei on Query {\n  voters: wrappedDelegates(first: $first, after: $after, orderBy: $orderBy, where: $filterBy) {\n    edges {\n      node {\n        id\n        ...VoterCardFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment NounGridFragment on Delegate {\n  delegatedVotesRaw\n  nounsRepresented(first: 60) {\n    id\n    ...NounImageFragment\n  }\n}\n\nfragment NounImageFragment on Noun {\n  number\n  seed {\n    accessory\n    background\n    body\n    glasses\n    head\n    id\n  }\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment VoterCardDelegateProfileImage on WrappedDelegate {\n  address {\n    resolvedName {\n      address\n    }\n  }\n  delegate {\n    nounsRepresented(first: 60) {\n      id\n    }\n    ...NounGridFragment\n    id\n  }\n}\n\nfragment VoterCardFragment on WrappedDelegate {\n  ...VoterPanelActionsFragment\n  ...VoterCardDelegateProfileImage\n  address {\n    resolvedName {\n      address\n      name\n      ...NounResolvedNameFragment\n    }\n  }\n  statement {\n    statement\n    summary\n  }\n  delegate {\n    id\n    delegatedVotesRaw\n    nounsRepresented(first: 60) {\n      __typename\n      id\n    }\n    voteSummary {\n      totalVotes\n    }\n  }\n}\n\nfragment VoterPanelActionsFragment on WrappedDelegate {\n  statement {\n    twitter\n    discord\n  }\n  ...VoterPanelDelegateButtonFragment\n}\n\nfragment VoterPanelDelegateButtonFragment on WrappedDelegate {\n  ...DelegateDialogFragment\n}\n"
  }
};
})();

(node as any).hash = "681ab6d2614eeb7ff66404a5a8ff8807";

export default node;
